import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback
} from 'react';
import {
  YMaps,
  Map,
  Placemark,
  Polyline
} from 'react-yandex-maps';
import { formatMessage } from 'devextreme/localization';
import { LoadPanel } from 'devextreme-react/load-panel';

import style from './infomap.module.scss';

const InfoMap = ({
  userReducer: { id },
  pieceInfoReducer: { details },
  infoMapReducer: {
    loading,
    mapData
  },
  tabSelect
  // getMap
}) => {
  const refMap = useRef(null);
  const [coordinates, setCoordinates] = useState(null);
  const [markers, setMarkers] = useState([]);
  // useEffect(() => {
  //   if (id && details && details.deliveryId) {
  //     getMap({
  //       basebtdid: details.deliveryId
  //     });
  //   }
  //   if (id && details && details.freightOrder) {
  //     getMap({
  //       freightOrder: details.freightOrder
  //     });
  //   }
  // }, [details, getMap, id]);
  useEffect(() => {
    if (mapData && mapData.zzevmlatitude) {
      setCoordinates({
        zzevmlatitude: mapData.zzevmlatitude, // широта
        zzevmlongitude: mapData.zzevmlongitude // долгота
      });
      setMarkers([
        {
          location: [mapData.zzevmlatitude, mapData.zzevmlongitude],
          tooltip: { text: mapData.zzstdislname }
        }
      ]);
    }
  }, [mapData]);

  // useEffect(() => {
  //   if (tabSelect === 'map' && mapData && mapData.trip && refMap.current) {
  //     setTimeout(() => {
  //       if (
  //         mapData.trip.departureLocation.latitude.toFixed(3)
  //         > mapData.trip.deliveryLocation.latitude.toFixed(3)
  //       ) {
  //         refMap.current.setBounds([
  //           [
  //             mapData.trip.departureLocation.latitude.toFixed(3),
  //             mapData.trip.departureLocation.longitude.toFixed(3)
  //           ],
  //           [
  //             mapData.trip.deliveryLocation.latitude.toFixed(3),
  //             mapData.trip.deliveryLocation.longitude.toFixed(3)
  //           ]
  //         ], {
  //           checkZoomRange: false,
  //           preciseZoom: false
  //         });
  //       } else {
  //         refMap.current.setBounds([
  //           [
  //             mapData.trip.deliveryLocation.latitude.toFixed(3),
  //             mapData.trip.deliveryLocation.longitude.toFixed(3)
  //           ],
  //           [
  //             mapData.trip.departureLocation.latitude.toFixed(3),
  //             mapData.trip.departureLocation.longitude.toFixed(3)
  //           ]
  //         ], {
  //           checkZoomRange: false,
  //           preciseZoom: false
  //         });
  //       }
  //     }, 1000);
  //   }
  //   if (tabSelect === 'map' && mapData && mapData.zzevmlatitude && refMap.current) {
  //     setTimeout(() => {
  //       refMap.current.setCenter(
  //         [mapData.zzevmlatitude, mapData.zzevmlongitude]
  //       );
  //     }, 1000);
  //   }
  //   // eslint-disable-next-line
  // }, [mapData, refMap.current, tabSelect]);

  const onLoad = useCallback(() => {
    if (mapData && mapData.trip && refMap.current) {
      if (
        mapData.trip.departureLocation.latitude.toFixed(3)
        > mapData.trip.deliveryLocation.latitude.toFixed(3)
      ) {
        refMap.current.setBounds([
          [
            mapData.trip.departureLocation.latitude.toFixed(3),
            mapData.trip.departureLocation.longitude.toFixed(3)
          ],
          [
            mapData.trip.deliveryLocation.latitude.toFixed(3),
            mapData.trip.deliveryLocation.longitude.toFixed(3)
          ]
        ], {
          checkZoomRange: false,
          preciseZoom: false
        });
      } else {
        refMap.current.setBounds([
          [
            mapData.trip.deliveryLocation.latitude.toFixed(3),
            mapData.trip.deliveryLocation.longitude.toFixed(3)
          ],
          [
            mapData.trip.departureLocation.latitude.toFixed(3),
            mapData.trip.departureLocation.longitude.toFixed(3)
          ]
        ], {
          checkZoomRange: false,
          preciseZoom: false
        });
      }
    } else if (mapData && mapData.zzevmlatitude && refMap.current) {
      refMap.current.setCenter(
        [mapData.zzevmlatitude, mapData.zzevmlongitude]
      );
    }
  }, [mapData]);

  const mapRender = useMemo(() => (
    <Placemark modules={['geoObject.addon.balloon']}
               defaultGeometry={markers.length && markers[0].location}
               properties={{ balloonContentBody: markers.length && markers[0].tooltip.text }}
    />
  ), [markers]);

  const mapRenderCar = useMemo(() => (
    <>
      <Polyline geometry={
          mapData
          && mapData.track
          && mapData.track.map((item) => ([item.latitude, item.longitude]))
        }
                options={{
                  balloonCloseButton: false,
                  strokeColor: '#000',
                  strokeWidth: 4,
                  strokeOpacity: 0.5
                }}
      />
      <Placemark modules={['geoObject.addon.balloon']}
                 defaultGeometry={
          mapData
          && mapData.trip
          && [mapData.trip.deliveryLocation.latitude, mapData.trip.deliveryLocation.longitude]
        }
                 properties={{ balloonContentBody: '' }}
                 options={{
                   iconLayout: 'default#image',
                   iconImageHref: '/images/map-b.png',
                   iconImageSize: [44, 44],
                   iconImageOffset: [-15, -40]
                 }}
      />
      <Placemark modules={['geoObject.addon.balloon']}
                 defaultGeometry={
          mapData
          && mapData.trip
          && [mapData.trip.departureLocation.latitude, mapData.trip.departureLocation.longitude]
        }
                 properties={{ balloonContentBody: '' }}
                 options={{
                   iconLayout: 'default#image',
                   iconImageHref: '/images/map-a.png',
                   iconImageSize: [44, 44],
                   iconImageOffset: [-15, -40]
                 }}
      />
    </>
  ), [mapData]);

  const renderYandexMap = useMemo(() => (
    <YMaps query={{
      apikey: '6bb15068-9a3c-4096-adee-9a15cdce5539',
      lang: 'ru_RU'
    }}>
      <Map state={{
        center: markers.length && markers[0].location ? markers[0].location : [55.75, 37.57],
        zoom: 7,
        controls: ['zoomControl', 'fullscreenControl']
      }}
           className={style.map}
           modules={['control.ZoomControl', 'control.FullscreenControl']}
           instanceRef={refMap}
           onLoad={onLoad}
      >
        {mapData && mapData.zzevmlatitude ? mapRender : null}
        {mapData && mapData.track ? mapRenderCar : null}
        {mapData && !mapData.zzevmlatitude && !mapData.track ? mapRender : null}
      </Map>
    </YMaps>
  ), [
    mapData,
    mapRender,
    mapRenderCar,
    markers,
    onLoad
  ]);

  return (
    <div className={style.main}>
      {(
        // eslint-disable-next-line no-nested-ternary
        coordinates
          ? (
            <div className="coordinates">
              <span>{formatMessage('textInfoTab').coordinates}</span>
              {` [${coordinates.zzevmlatitude}, ${coordinates.zzevmlongitude}]`}
            </div>
          )
          : (
            mapData && mapData.trip
              ? (
                <div className="coordinates">
                  <span>
                    {mapData.trip.transportCompanyName ? `${mapData.trip.transportCompanyName}; ` : ''}
                    {mapData.trip.vehicleNumber ? `${mapData.trip.vehicleNumber}; ` : ''}
                    {mapData.trip.deliveryCity ? `${mapData.trip.deliveryCity}; ` : ''}
                    {mapData.trip.deliveryStreet ? `${mapData.trip.deliveryStreet}; ` : ''}
                    {mapData.trip.deliveryHouse ? `${mapData.trip.deliveryHouse}; ` : ''}
                  </span>
                </div>
              )
              : (
                <div className="coordinates">
                  <span>{formatMessage('textInfoTab').notCoordinates}</span>
                </div>
              )
          )
      )}
      {renderYandexMap}
      <LoadPanel shadingColor={'rgba(0,0,0,0.4)'}
                 showPane
                 shading={false}
                 showIndicator
                 visible={loading}
      />
    </div>
  );
};

export default InfoMap;
